module.exports = __webpack_public_path__ + "img/faucet.42a173ca.jpg";